<template>
  <div>
    <v-card elevation="0" class="px-7">
      <v-row dense align="center" justify="space-between">
        <v-col cols="12" sm="6">
          <h1 class="fs-16 primary--text font-weight-bold">
            Dashboard
          </h1>
        </v-col>
        <v-col cols="12" sm="auto">
          <v-breadcrumbs class="app-breadcrumbs py-3" :items="breadcrumbs" />
        </v-col>
      </v-row>
      <v-tabs
        class="nav-tabs"
        v-model="tab"
        background-color="white"
        color="menuActive"
      >
        <v-tabs-slider></v-tabs-slider>
        <v-tab
          v-for="(item, index) in filters"
          :key="index"
          class="text-left px-0 d-block pt-3 mr-10"
          style="min-width: 120px !important; height:100%"
        >
          <span class="text-capitalize fs-12 font-weight-600 text-left">
            {{ item.name }}
          </span>
        </v-tab>
        <v-spacer></v-spacer>

        <dashboard-filter />
        <!--        <date-picker-->
        <!--          v-model="year"-->
        <!--          type="year"-->
        <!--          placeholder="Filter"-->
        <!--          format="YYYY"-->
        <!--          class="dashSearch filterSearch mt-2 ml-3 rounded-xl"-->
        <!--          style="width: 135px !important;"-->
        <!--        >-->
        <!--        </date-picker>-->
      </v-tabs>
    </v-card>

    <dashboard-tab-item v-if="tabItem" :item="tabItem" />
  </div>
</template>

<script>
import DashboardTabItem from '@/components/SSHCF/DashboardTabItem';
import DashboardFilter from '@/components/SSHCF/DashboardFilter';

export default {
  components: { DashboardFilter, DashboardTabItem },
  data: () => ({
    dialogFilter: false,
    tab: 0,
    filters: [
      {
        name: 'House'
      },
      {
        name: 'Region'
      },
      {
        name: 'District'
      }
    ],
    year: new Date().getFullYear(),
    breadcrumbs: [
      {
        text: 'SSHCF',
        to: '/'
      },
      {
        text: 'Dashboard',
        to: '/'
      }
    ],
    isFilter: false,
    isReset: false,
    isDownload: false
  }),
  computed: {
    tabItem() {
      return this.filters[this.tab];
    }
  },
  methods: {}
};
</script>
